<div class="table-container">
  <p-table #dt class="tabela-contas" [value]="contas" dataKey="id" responsiveLayout="scroll" [expandedRowKeys]="expandedRows" editMode="row"
    (click)="$event.stopPropagation()" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]"
    [globalFilterFields]="['nome']">

    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th pSortableColumn="nome">Conta<p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="quantidadeTipos">Tipos<p-sortIcon field="quantidadeTipos"></p-sortIcon></th>
        <th pSortableColumn="quantidadeLancamentos">Lançamentos<p-sortIcon field="quantidadeLancamentos"></p-sortIcon></th>
        <th pSortableColumn="dataUltimoLancamento">Último lançamento<p-sortIcon field="dataUltimoLancamento"></p-sortIcon></th>
        <th class="col-acoes"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-conta let-expanded="expanded" let-editing="editing">
      <tr [pEditableRow]="conta">
        <td>
          <p-button type="button" pRipple [pRowToggler]="conta" [text]="true" [rounded]="true" [plain]="true"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
          </p-button>
        </td>

        <td>
          <p-cellEditor>
            <ng-template #input>
              <input pInputText type="text" [(ngModel)]="conta.nome" />
            </ng-template>
            <ng-template #output>
              {{ conta.nome }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>{{ conta.quantidadeTipos }}</td>
        <td>{{ conta.quantidadeLancamentos }}</td>
        <td>{{ conta.dataUltimoLancamento | date:'dd/MM/yyyy' }}</td>

        <td>
          @if (!editing) {
            <div class="inline-element items-center">
              <button pButton icon="pi pi-pencil" pInitEditableRow text rounded severity="secondary"
                matTooltip="Editar nome" (click)="onRowEditContaInit(conta)">
              </button>
              <button pButton icon="pi pi-ellipsis-v" text rounded severity="secondary" [matMenuTriggerFor]="menuConta">
              </button>
              <mat-menu #menuConta="matMenu" xPosition="before">
                @for (acao of acoesConta; track acao) {
                  @if (acaoContaVisivel(acao, conta)) {
                    <button mat-menu-item class="inline-element accent-color"
                      (click)="acao.acao(conta)">
                      <i class="button-menu-icon pi {{ acao.icon }}"></i>
                      {{ acao.label }}
                    </button>
                  }
                }
              </mat-menu>
            </div>
          }

          @if (editing) {
            <div class="inline-element items-center">
              <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
              (click)="onRowEditContaSave(conta)" text rounded severity="secondary"></button>
              <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
              (click)="onRowEditContaCancel(conta)" text rounded severity="secondary"></button>
            </div>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-conta>
      <tr>
        <td colspan="6">
          <div class="table-container">

            <div class="inner-table-toolbar">
              <div class="inner-table-busca">
                <p-floatLabel variant="on">
                  <p-iconField iconPosition="left">
                    <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
                    <input pInputText
                      (input)="innerDt.filterGlobal($any($event.target).value, 'contains')" />
                    </p-iconField>
                    <label>Buscar tipo</label>
                  </p-floatLabel>
                </div>

                <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

                @if (!estaEmModoSelecao(conta)) {
                  <ng-container *hasPermission="permissaoEditarTipoLancamento">
                    @if (mostrarAdicionarTipo) {
                      <button pButton icon="pi pi-plus" text rounded severity="secondary"
                        matTooltip="Adicionar tipo" (click)="adicionarTipoClick(conta)">
                      </button>
                    }
                    @if (mostrarSelecaoEmMassa) {
                      <button pButton icon="pi pi-check-square" text rounded severity="secondary"
                        matTooltip="Editar tipos em massa" (click)="ativarModoSelecao(conta)">
                      </button>
                    }
                  </ng-container>
                }

                @if (estaEmModoSelecao(conta)) {
                  <span class="selecao-toolbar">
                    <span class="selecao-contador">{{ qtdSelecionados }} selecionado(s)</span>
                    <ng-container *hasPermission="permissaoEditarTipoLancamento">
                      <button pButton icon="pi pi-arrow-right-arrow-left" text rounded severity="secondary"
                        matTooltip="Alterar conta" (click)="alterarContaEmMassaClick(conta)">
                      </button>
                      <button pButton icon="pi pi-arrow-down-left-and-arrow-up-right-to-center" text rounded severity="secondary"
                        matTooltip="Mesclar tipos" (click)="mesclarTiposEmMassaClick(conta)">
                      </button>
                    </ng-container>
                    <button pButton icon="pi pi-times" text rounded severity="secondary"
                      matTooltip="Cancelar seleção" (click)="cancelarModoSelecao()">
                    </button>
                  </span>
                }
              </div>

              <p-table #innerDt [value]="conta.tipos" dataKey="id" responsiveLayout="scroll" editMode="row"
                [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]"
                [globalFilterFields]="['nome']"
                [selectionMode]="estaEmModoSelecao(conta) ? 'multiple' : undefined"
                [(selection)]="tiposSelecionados"
                paginatorDropdownAppendTo="body">

                <ng-template pTemplate="header">
                  <tr>
                    @if (estaEmModoSelecao(conta)) {
                      <th class="col-checkbox">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                      </th>
                    }
                    <th pSortableColumn="nome">Tipo<p-sortIcon field="nome"></p-sortIcon></th>
                    <th pSortableColumn="quantidadeLancamentos">Lançamentos<p-sortIcon field="quantidadeLancamentos"></p-sortIcon></th>
                    <th pSortableColumn="dataUltimoLancamento">Último lançamento<p-sortIcon field="dataUltimoLancamento"></p-sortIcon></th>
                    <th class="col-acoes"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-tipo let-editing="editing" let-rowIndex="rowIndex">
                  <tr [pEditableRow]="tipo" [pSelectableRow]="tipo" [pSelectableRowIndex]="rowIndex"
                    [pSelectableRowDisabled]="!estaEmModoSelecao(conta)">
                    @if (estaEmModoSelecao(conta)) {
                      <td class="col-checkbox">
                        <p-tableCheckbox [value]="tipo"></p-tableCheckbox>
                      </td>
                    }

                    <td>
                      <p-cellEditor>
                        <ng-template #input>
                          <input pInputText type="text" [(ngModel)]="tipo.nome" />
                        </ng-template>
                        <ng-template #output>
                          {{ tipo.nome }}
                        </ng-template>
                      </p-cellEditor>
                    </td>

                    <td>{{ tipo.quantidadeLancamentos }}</td>
                    <td>{{ tipo.dataUltimoLancamento | date:'dd/MM/yyyy' }}</td>

                    <td>
                      @if (!editing && !estaEmModoSelecao(conta)) {
                        <div class="inline-element">
                          <ng-container *hasPermission="permissaoEditarTipoLancamento">
                            <button pButton icon="pi pi-pencil" pInitEditableRow text rounded
                              severity="secondary" matTooltip="Editar nome" (click)="onRowEditTipoInit(tipo)">
                            </button>
                            <button pButton icon="pi pi-ellipsis-v" text rounded severity="secondary" [matMenuTriggerFor]="menuTipo">
                            </button>
                          </ng-container>
                          <mat-menu #menuTipo="matMenu" xPosition="before">
                            <button mat-menu-item class="inline-element accent-color"
                              (click)="alterarContaTipoClick(tipo, conta)">
                              <i class="button-menu-icon pi pi-arrow-right-arrow-left"></i>
                              Alterar conta
                            </button>
                            <button mat-menu-item class="inline-element accent-color"
                              (click)="mesclarTiposClick(tipo, conta)">
                              <i class="button-menu-icon pi pi-arrow-down-left-and-arrow-up-right-to-center"></i>
                              Mesclar tipos
                            </button>
                          </mat-menu>
                        </div>
                      }

                      @if (editing) {
                        <div class="inline-element items-center">
                          <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                          (click)="onRowEditTipoSave(tipo)" text rounded severity="secondary"></button>
                          <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                          (click)="onRowEditTipoCancel(tipo)" text rounded severity="secondary"></button>
                        </div>
                      }
                    </td>
                  </tr>
                </ng-template>
              </p-table>

            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
